import {Component, OnInit, ViewChild} from '@angular/core';
import {StellenService} from '../stellen.service';
import {PersDaten} from './PersDaten';
import {Datei} from './Dateien';
import {HttpHeaders} from '@angular/common/http';
import {ActivatedRoute} from '@angular/router';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {environment} from '../../environments/environment';
import {DateAdapter, MAT_DATE_FORMATS, MatDialog, MatDialogRef} from '@angular/material';
import {APP_DATE_FORMATS, AppDateAdapter} from './format-datepicker';

@Component({
    selector: 'app-bewerbung',
    templateUrl: './bewerbung.component.html',
    styleUrls: ['./bewerbung.component.css'],
    providers: [
        {provide: DateAdapter, useClass: AppDateAdapter},
        {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS}
    ]
})
export class BewerbungComponent implements OnInit {

    constructor(private stellenService: StellenService,
                private route: ActivatedRoute,
                private router: Router,
                private location: Location) {
    }

    @ViewChild('captchaRef') recaptchaRef;
    codesystems: object = {};
    persDaten: PersDaten = new PersDaten();
    recaptcha: object = {'id': null, 'error': false, 'errorMessage': ''};
    schritt = 1;
    dateien: object = {};
    dateiError = false;
    stellenId: String = '';
    stelle: object;
    wahr = false;
    bewerbungLaeuft = false;
    weitereQuellen = false;
    formError = false;
    recaptchaKey = environment.recaptchaKey;
    validMimeTypes = [
        'application/pdf',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.sun.xml.writer',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'image/tiff',
        'image/jpeg'
    ];
    showSpinner = true;

    minDate = new Date(1900, 0, 1);
    maxDate = new Date();

    ngOnInit() {
        window.scroll(0, 0);
        this.showSpinner = true;
        if (this.route.snapshot.data.spezialstelle) {
            this.stellenService.getStellenangebote(false, '').then((response) => {
                for (const stelle of response) {
                    if (stelle.data.titel === this.route.snapshot.data.spezialstelle
                        && stelle.data.mandant === this.stellenService.mandant) {
                        this.stelle = stelle.data;
                        break;
                    }
                }
            });
        } else {
            this.stellenId = this.route.snapshot.params.id;
            this.stellenService.getStellenangebote(false, '').then((response) => {
                for (const stelle of response) {
                    if (stelle.id === this.stellenId) {
                        this.stelle = stelle.data;
                        break;
                    }
                }
            });
        }

        this.stellenService.getCodesystems().then((response) => {
            this.codesystems = response;
            this.showSpinner = false;
        });

    }

    captchaResolved(captchaResponse: string) {
        this.recaptcha['id'] = captchaResponse;
        this.recaptcha['error'] = false;
    }

    goBack(schritt: number) {
        window.scroll(0, 0);
        this.dateien = {};
        this.schritt = schritt;
    }

    goMenu() {
        this.location.back();
    }

    eingabenValidieren() {
        this.formError = false;

        Object.keys(this.persDaten).forEach(key => {
            this.persDaten[key].fehler = false;
            if (this.persDaten[key].pflichtfeld) {
                if (this.persDaten[key].wert.length === 0) {
                    this.persDaten[key].fehler = true;
                    this.formError = true;
                } else {
                    if (key === 'email' && !this.validateEmail(this.persDaten[key].wert)) {
                        this.persDaten[key].fehler = true;
                        this.formError = true;
                    } else if (key !== 'hausnummer' && this.persDaten[key].wert.length < 2) {
                        this.persDaten[key].fehler = true;
                        this.formError = true;
                    }
                }
            } else if ((key === 'telefon' || key === 'handy')
                && this.persDaten[key].wert.length > 0 && !this.validatePhoneNUmber(this.persDaten[key].wert)) {
                this.persDaten[key].fehler = true;
                this.formError = true;
            } else if (key === 'geburtsdatum' && this.persDaten[key].wert.length > 0) {
                const geburtsdatum = new Date(this.persDaten[key].wert);
                const currentDate = new Date();
                if (geburtsdatum >= currentDate) {
                    this.persDaten[key].fehler = true;
                    this.formError = true;
                }
            }
        });

        if (!this.formError) {
            window.scroll(0, 0);
            this.schritt = 2;
        }
    }

    validateEmail(email) {
        const re = /.*@.*\..*/;
        return re.test(String(email).toLowerCase());
    }

    validatePhoneNUmber(phone) {
        const re = /^\+?[0-9]\d{5,12}$/;
        return re.test(String(phone).toLowerCase());
    }

    dateiHochladen(fileList: FileList, dateiArt) {
        const file = fileList.item(0);
        if (file) {
            if(!this.dateien[dateiArt]){
                this.dateien[dateiArt] = new Datei();
            }
            this.validateMimeType(file).then(validMimeType => {
                    if (file && this.validMimeTypes.indexOf(file.type) === -1 || file.size > 50000000 || !validMimeType) {
                        this.dateien[dateiArt]['error'] = true;
                        return;
                    }
                    this.dateien[dateiArt]['file'] = file;
                    this.dateien[dateiArt]['error'] = false;
                }
            );
        }
    }

    validateMimeType(file) {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.onloadend = function (e) {
                const arr = (new Uint8Array(e.target.result)).subarray(0, 4);
                let header = '';
                for (let i = 0; i < arr.length; i++) {
                    header += arr[i].toString(16);
                }
                switch (header) {
                    // PDF
                    case '25504446':
                        resolve(true);
                        break;
                    // DOC
                    case '504b34':
                        resolve(true);
                        break;
                    // TIFF
                    case '49492a0':
                    case '4d4d02a':
                        resolve(true);
                        break;
                    // JPG
                    case 'ffd8ffe0':
                    case 'ffd8ffe1':
                    case 'ffd8ffe2':
                    case 'ffd8ffe3':
                    case 'ffd8ffe8':
                        resolve(true);
                        break;
                    default:
                        resolve(false);
                }

            };
            fileReader.readAsArrayBuffer(file);
        });
    }

    dateienValidieren() {
        this.dateiError = false;
        let atLeastOne = false;
        for (let dateienKey in this.dateien){
            atLeastOne = true;
            if(!this.dateien[dateienKey].file || this.dateien[dateienKey].error) {
                this.dateiError = true;
                break;
            }
        }
        if(!this.dateiError && atLeastOne){
            window.scroll(0, 0);
            this.schritt = 3;
        }
    }

    bewerben() {
        this.bewerbungLaeuft = true;
        // Bewerber anlegen
        const bewerberBody: {} = {
            'captchaID': this.recaptcha['id'],
            'eingangskanal': 'Bewerberportal',
            'primaerstelle': this.stelle['titelstellenid'],
            'bewerbungseingang': new Date()
        };
        if (this.persDaten.schwerbehinderung.wert) {
            bewerberBody['schwerbehinderung'] = this.persDaten.schwerbehinderung.wert;
        }
        if (this.persDaten.nachname.wert) {
            bewerberBody['nachname'] = this.persDaten.nachname.wert;
        }
        if (this.persDaten.vorname.wert) {
            bewerberBody['vorname'] = this.persDaten.vorname.wert;
        }
        if (this.persDaten.anrede.wert) {
            bewerberBody['anrede'] = this.persDaten.anrede.wert;
            if (this.persDaten.anrede.wert === 'Herr') {
                bewerberBody['anredelang'] = 'Sehr geehrter Herr';
            } else if (this.persDaten.anrede.wert === 'Frau') {
                bewerberBody['anredelang'] = 'Sehr geehrte Frau';
            }
        }
        if (this.persDaten.titel.wert) {
            bewerberBody['titel'] = this.persDaten.titel.wert;
        }
        if (this.persDaten.geburtsdatum.wert) {
            bewerberBody['geburtsdatum'] = this.persDaten.geburtsdatum.wert;
        }
        if (this.persDaten.familienstand.wert) {
            bewerberBody['familienstand'] = this.persDaten.familienstand.wert;
        }
        if (this.persDaten.telefon.wert) {
            bewerberBody['telefonprivat'] = this.persDaten.telefon.wert;
        }
        if (this.persDaten.handy.wert) {
            bewerberBody['telefonmobil'] = this.persDaten.handy.wert;
        }
        if (this.persDaten.email.wert) {
            bewerberBody['email'] = this.persDaten.email.wert;
        }
        if (this.persDaten.nationalitaet.wert) {
            bewerberBody['staatsangehoerigkeit'] = this.persDaten.nationalitaet.wert;
        }
        if (this.persDaten.quelle.wert) {
            bewerberBody['bewerbungskanal'] = this.persDaten.quelle.wert;
        }
        if (this.persDaten.strasse.wert) {
            bewerberBody['strasse'] = this.persDaten.strasse.wert + ' ' + this.persDaten.hausnummer.wert;
        }
        if (this.persDaten.plz.wert) {
            bewerberBody['postleitzahl'] = this.persDaten.plz.wert;
        }
        if (this.persDaten.ort.wert) {
            bewerberBody['ort'] = this.persDaten.ort.wert;
        }
        if (this.persDaten.land.wert) {
            bewerberBody['land'] = this.persDaten.land.wert;
        }
        let bewerberId: string;
        this.stellenService.bewerberAnlegen(bewerberBody).then((bewerberResponse) => {
            if (bewerberResponse['error']) {
                this.recaptchaRef.reset();
                this.recaptcha['error'] = true;
                this.recaptcha['errorMessage'] = 'reCAPTCHA konnte nicht verifiziert werden, bitte erneut ausführen.';
                this.recaptcha['id'] = null;
                this.bewerbungLaeuft = false;
            } else {
                bewerberId = bewerberResponse['id'];

                // Bewerbungsunterlagen anlegen

                const promiseArr = [];

                const headers = new HttpHeaders();

                headers.append('Content-Type', 'multipart/form-data');
                headers.append('Accept', 'application/json');

                for (let dateienKey in this.dateien){
                    if(this.dateien[dateienKey].file){
                        const formData: FormData = new FormData();
                        const file: File = this.dateien[dateienKey].file;
                        formData.append('file', file, file.name);
                        promiseArr.push(this.stellenService.bewerbungsunterlageAnlegen(bewerberId, formData, headers));
                    }
                }
                /*
                if (this.dateien.gesamtbewerbung.file) {
                    const formData: FormData = new FormData();
                    const file: File = this.dateien.gesamtbewerbung.file;
                    formData.append('file', file, file.name);
                    promiseArr.push(this.stellenService.bewerbungsunterlageAnlegen(bewerberId, formData, headers));
                } else {
                    if (this.dateien.anschreiben.file) {
                        const formData: FormData = new FormData();
                        const file: File = this.dateien.anschreiben.file;
                        formData.append('file', file, file.name);
                        promiseArr.push(this.stellenService.bewerbungsunterlageAnlegen(bewerberId, formData, headers));
                    }
                    if (this.dateien.lebenslauf.file) {
                        const formData: FormData = new FormData();
                        const file: File = this.dateien.lebenslauf.file;
                        formData.append('file', file, file.name);
                        promiseArr.push(this.stellenService.bewerbungsunterlageAnlegen(bewerberId, formData, headers));
                    }
                    if (this.dateien.lichtbild.file) {
                        const formData: FormData = new FormData();
                        const file: File = this.dateien.lichtbild.file;
                        formData.append('file', file, file.name);
                        promiseArr.push(this.stellenService.bewerbungsunterlageAnlegen(bewerberId, formData, headers));
                    }
                    if (this.dateien.zeugnisse.file) {
                        const formData: FormData = new FormData();
                        const file: File = this.dateien.zeugnisse.file;
                        formData.append('file', file, file.name);
                        promiseArr.push(this.stellenService.bewerbungsunterlageAnlegen(bewerberId, formData, headers));
                    }
                }
                */
                Promise.all(promiseArr).then(resolves => {
                    const itemIds: string[] = [];
                    resolves.forEach(res => {
                        if (res === 'error') {
                            this.bewerbungLaeuft = false;
                        } else {
                            itemIds.push(res['id']);
                        }
                    });
                    const body: object = {
                        'itemIds': itemIds,
                        'mandant': this.stelle['mandant'],
                        'contents': [
                            {
                                'id': bewerberId,
                                'type': 'bewerber'
                            }
                        ]
                    };
                    this.stellenService.bewerben(body).then((bewerbenResponse) => {
                        if (bewerbenResponse.hasOwnProperty('name')) {
                            this.stellenService.processId = bewerbenResponse['name'];
                            this.stellenService.showPopup = true;
                            const emailBody: object = {
                                'mandant': this.stelle['mandant'],
                                'id': bewerberId
                            };
                            this.stellenService.email(emailBody);
                            this.router.navigate(['/']);
                        } else {
                            this.bewerbungLaeuft = false;
                        }
                    });
                });

            }
        });
    }
}
